import { render, staticRenderFns } from "./UIBlockColumnField.template.vue?vue&type=template&id=f065b5ca&scoped=true&"
var script = {}
import style0 from "./UIBlockColumnField.template.vue?vue&type=style&index=0&id=f065b5ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f065b5ca",
  null
  
)

export default component.exports